import React from 'react';
import Quiz from '../../components/Quiz';

const QuizPage = () => <Quiz />;

export default QuizPage;
